import React from 'react'
import ErrorMessage from "../error-message/ErrorMessage";
import IInputFieldProps from "../../interfaces/iinput_field_props.type";
import './InputField.scss'


const InputField: React.FunctionComponent<IInputFieldProps> = ({
   id,
   name,
   label,
   type,
   handleChange,
   value,
   className,
   placeholder,
   testId,
   isValid = true,
   errorMessage = '',
   min
}) => {

   return (
      <div className='input-div'>
         <label data-testid={`testid-${id}`} htmlFor={id} className='label'>{label}</label>
         <input
            id={id}
            className={className}
            type={type}
            min={min}
            name={name}
            placeholder={placeholder}
            onChange={handleChange}
            value={value}
            data-testid={testId}
         />
         { isValid === false && value !== '' && (
             <ErrorMessage message={errorMessage} id={`input-${name}-error-div`} className='error-div' testId={`input-${name}-error-testid`} />
         )}
      </div>
   )
}

export default InputField
